import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  plugins: [
    createPersistedState(),
  ],
  state: {
    instance: '',
    endpoint: process.env.EP_PROTO + process.env.EP_BASE,
    token: null,
    user: null,
    isUserLoggedIn: false,
  },
  getters: {
    instance: (state) => state.instance,
    endpoint: (state) => state.endpoint,
    token: (state) => state.token,
  },
  mutations: {
    setInstance(state, instance) {
      if (instance.length === 0 || instance === 'default') {
        state.instance = '';
        state.endpoint = process.env.EP_PROTO + process.env.EP_BASE;
      } else {
        state.instance = instance;
        state.endpoint = `${process.env.EP_PROTO}${instance}.${process.env.EP_BASE}`;
      }
    },
    setToken(state, token) {
      state.token = token;
      state.isUserLoggedIn = !!(token);
    },
    setUser(state, user) {
      state.user = user;
    },
    logout(state) {
      state.token = null;
      state.isUserLoggedIn = false;
      state.user = null;
    },
  },
  actions: {
    setInstance({ commit }, instance) {
      commit('setInstance', instance);
    },
    setToken({ commit }, token) {
      commit('setToken', token);
    },
    setUser({ commit }, user) {
      commit('setUser', user);
    },
    logout({ commit }) {
      commit('logout');
    },
  },
});
